import { Product } from '../types';

// ============================================
// UNIVERSAL HOLDERS - DELUXE WIRE
// ============================================

// 0250 SERIES UNIVERSAL HOLDERS
export const holder0250SeriesProducts: Product[] = [
  {
    id: "holder-0250-1p",
    name: "Universal Holder 1 Pole - 0250 Series",
    slug: "universal-holder-1-pole-0250",
    category: "Universal Holders",
    subcategory: "0250 Series Holders",
    description: "Universal 1 pole female and male holder with 4mm deluxe wire. 9 inch long wire. 0250 series.",
    partNumber: "SH0100001F / SH0100001M",
    featured: true,
    specifications: {
      "Series": "0250 (6.3mm)",
      "Poles": "1 Pole",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches (229mm)",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "universal", "0250", "1-pole", "deluxe-wire"],
    applications: ["Automotive", "Universal Wiring", "Connector Assembly"],
  },
  {
    id: "holder-0250-2p",
    name: "Universal Holder 2 Pole - 0250 Series",
    slug: "universal-holder-2-pole-0250",
    category: "Universal Holders",
    subcategory: "0250 Series Holders",
    description: "Universal 2 pole female and male holder with 4mm deluxe wire.",
    partNumber: "SH0100002F / SH0100002M",
    featured: true,
    specifications: {
      "Series": "0250 (6.3mm)",
      "Poles": "2 Pole",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "universal", "0250", "2-pole"],
    applications: ["Automotive", "Universal Wiring"],
  },
  {
    id: "holder-0250-3p",
    name: "Universal Holder 3 Pole - 0250 Series",
    slug: "universal-holder-3-pole-0250",
    category: "Universal Holders",
    subcategory: "0250 Series Holders",
    description: "Universal 3 pole female and male holder with 4mm deluxe wire.",
    partNumber: "SH0100003F / SH0100003M",
    specifications: {
      "Series": "0250 (6.3mm)",
      "Poles": "3 Pole",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "universal", "0250", "3-pole"],
    applications: ["Automotive", "Universal Wiring"],
  },
  {
    id: "holder-0250-4p",
    name: "Universal Holder 4 Pole - 0250 Series",
    slug: "universal-holder-4-pole-0250",
    category: "Universal Holders",
    subcategory: "0250 Series Holders",
    description: "Universal 4 pole female and male holder with 4mm deluxe wire.",
    partNumber: "SH0100004F / SH0100004M",
    specifications: {
      "Series": "0250 (6.3mm)",
      "Poles": "4 Pole",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "universal", "0250", "4-pole"],
    applications: ["Automotive", "Universal Wiring"],
  },
  {
    id: "holder-0250-6p",
    name: "Universal Holder 6 Pole - 0250 Series",
    slug: "universal-holder-6-pole-0250",
    category: "Universal Holders",
    subcategory: "0250 Series Holders",
    description: "Universal 6 pole female and male holder with 4mm deluxe wire.",
    partNumber: "SH0100006F / SH0100006M",
    featured: true,
    specifications: {
      "Series": "0250 (6.3mm)",
      "Poles": "6 Pole",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "universal", "0250", "6-pole"],
    applications: ["Automotive", "Universal Wiring"],
  },
  {
    id: "holder-0250-8p",
    name: "Universal Holder 8 Pole - 0250 Series",
    slug: "universal-holder-8-pole-0250",
    category: "Universal Holders",
    subcategory: "0250 Series Holders",
    description: "Universal 8 pole female and male holder with 4mm deluxe wire.",
    partNumber: "SH0100008F / SH0100008M",
    specifications: {
      "Series": "0250 (6.3mm)",
      "Poles": "8 Pole",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "universal", "0250", "8-pole"],
    applications: ["Automotive", "Universal Wiring"],
  },
  {
    id: "holder-0250-9p",
    name: "Universal Holder 9 Pole - 0250 Series",
    slug: "universal-holder-9-pole-0250",
    category: "Universal Holders",
    subcategory: "0250 Series Holders",
    description: "Universal 9 pole female and male holder with 4mm deluxe wire.",
    partNumber: "SH0100009F / SH0100009M",
    specifications: {
      "Series": "0250 (6.3mm)",
      "Poles": "9 Pole",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "universal", "0250", "9-pole"],
    applications: ["Automotive", "Universal Wiring"],
  },
  {
    id: "holder-0250-10p-ape",
    name: "Universal APE Holder 10 Pole - 0250 Series",
    slug: "universal-holder-10-pole-ape",
    category: "Universal Holders",
    subcategory: "0250 Series Holders",
    description: "Universal APE 10 pole female and male holder with 4mm deluxe wire.",
    partNumber: "SH0100010F / SH0100010M",
    specifications: {
      "Series": "0250 (6.3mm)",
      "Poles": "10 Pole",
      "Compatible": "APE",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "universal", "0250", "10-pole", "ape"],
    applications: ["APE", "3-Wheeler", "Automotive"],
  },
  {
    id: "holder-0250-tata-sumo-207",
    name: "Universal Tata Sumo 207 DI Holder - 5+2 Pole",
    slug: "universal-holder-tata-sumo-207-5-2",
    category: "Universal Holders",
    subcategory: "0250 Series Holders",
    description: "Universal Tata Sumo 207 DI 5+2 pole female and male holder with 5mm & 8mm deluxe wire.",
    partNumber: "SH0100014F / SH0100014M",
    featured: true,
    specifications: {
      "Series": "0250 (6.3mm)",
      "Poles": "5+2 Pole",
      "Compatible": "Tata Sumo 207 DI",
      "Wire Type": "5mm & 8mm Deluxe",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "universal", "0250", "tata-sumo", "207-di"],
    applications: ["Tata Sumo 207 DI", "Commercial Vehicles"],
  },
  {
    id: "holder-0250-tata-al-5-2",
    name: "Universal Tata & Ashok Leyland Holder - 5+2 Pole",
    slug: "universal-holder-tata-al-5-2",
    category: "Universal Holders",
    subcategory: "0250 Series Holders",
    description: "Universal Tata & Ashok Leyland 5+2 pole female and male holder with 5mm & 8mm deluxe wire.",
    partNumber: "SH0100015F / SH0100015M",
    featured: true,
    specifications: {
      "Series": "0250 (6.3mm)",
      "Poles": "5+2 Pole",
      "Compatible": "Tata & Ashok Leyland",
      "Wire Type": "5mm & 8mm Deluxe",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "universal", "0250", "tata", "ashok-leyland"],
    applications: ["Tata", "Ashok Leyland", "Commercial Vehicles"],
  },
];

// 090 SERIES UNIVERSAL HOLDERS
export const holder090SeriesProducts: Product[] = [
  {
    id: "holder-090-2w-1p",
    name: "2 Wheeler Holder 1 Pole - 090 Series",
    slug: "holder-2-wheeler-1-pole",
    category: "Universal Holders",
    subcategory: "090 Series Holders",
    description: "2 Wheeler 1 pole female and male holder with 4mm deluxe wire. 090 series.",
    partNumber: "SH0100031F / SH0100031M",
    specifications: {
      "Series": "090 (2.3mm)",
      "Poles": "1 Pole",
      "Compatible": "2 Wheeler",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090", "2-wheeler", "1-pole"],
    applications: ["2-Wheeler", "Motorcycle", "Scooter"],
  },
  {
    id: "holder-090-maruti-2p",
    name: "Maruti Car Type-II Holder 2 Pole - 090 Series",
    slug: "holder-maruti-2-pole",
    category: "Universal Holders",
    subcategory: "090 Series Holders",
    description: "Maruti Car Type-II 2 pole female and male holder with 4mm deluxe wire.",
    partNumber: "SH0100032F / SH0100032M",
    specifications: {
      "Series": "090 (2.3mm)",
      "Poles": "2 Pole",
      "Compatible": "Maruti Car Type-II",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090", "maruti", "2-pole"],
    applications: ["Maruti Cars", "Automotive"],
  },
  {
    id: "holder-090-tata-6p",
    name: "Tata Holder 6 Pole - 090 Series",
    slug: "holder-tata-6-pole",
    category: "Universal Holders",
    subcategory: "090 Series Holders",
    description: "Tata 6 pole female and male holder with special wire. 090 series.",
    partNumber: "SH0100036F / SH0100036M",
    specifications: {
      "Series": "090 (2.3mm)",
      "Poles": "6 Pole",
      "Compatible": "Tata",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090", "tata", "6-pole"],
    applications: ["Tata Vehicles", "Commercial"],
  },
  {
    id: "holder-090-maruti-8p",
    name: "Maruti Car Holder 8 Pole - 090 Series",
    slug: "holder-maruti-8-pole",
    category: "Universal Holders",
    subcategory: "090 Series Holders",
    description: "Maruti Car 8 pole female and male holder with special wire.",
    partNumber: "SH0100038F / SH0100038M",
    specifications: {
      "Series": "090 (2.3mm)",
      "Poles": "8 Pole",
      "Compatible": "Maruti Car",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090", "maruti", "8-pole"],
    applications: ["Maruti Cars"],
  },
  {
    id: "holder-090-mahindra-alfa-10p",
    name: "Mahindra Alfa Holder 10 Pole - 090 Series",
    slug: "holder-mahindra-alfa-10-pole",
    category: "Universal Holders",
    subcategory: "090 Series Holders",
    description: "Mahindra Alfa 10 pole female and male holder with special wire.",
    partNumber: "SH0100040F / SH0100040M",
    featured: true,
    specifications: {
      "Series": "090 (2.3mm)",
      "Poles": "10 Pole",
      "Compatible": "Mahindra Alfa",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090", "mahindra", "alfa", "10-pole"],
    applications: ["Mahindra Alfa", "3-Wheeler"],
  },
  {
    id: "holder-090-farmtrac-ape-12p",
    name: "Farmtrac Tractor & APE Holder 12 Pole - 090 Series",
    slug: "holder-farmtrac-ape-12-pole",
    category: "Universal Holders",
    subcategory: "090 Series Holders",
    description: "Farmtrac Tractor & APE 12 pole female and male holder with special wire.",
    partNumber: "SH0100042F / SH0100042M",
    specifications: {
      "Series": "090 (2.3mm)",
      "Poles": "12 Pole",
      "Compatible": "Farmtrac Tractor & APE",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090", "farmtrac", "ape", "tractor", "12-pole"],
    applications: ["Farmtrac Tractor", "APE", "Agricultural"],
  },
  {
    id: "holder-090-maruti-type3-13p",
    name: "Maruti Car Type-III Holder 13 Pole - 090 Series",
    slug: "holder-maruti-type3-13-pole",
    category: "Universal Holders",
    subcategory: "090 Series Holders",
    description: "Maruti Car Type-III 13 pole female and male holder with special wire.",
    partNumber: "SH0100043F / SH0100043M",
    specifications: {
      "Series": "090 (2.3mm)",
      "Poles": "13 Pole",
      "Compatible": "Maruti Car Type-III",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090", "maruti", "type-3", "13-pole"],
    applications: ["Maruti Cars"],
  },
  {
    id: "holder-090-al-tata-14p",
    name: "Ashok Leyland & Tata Holder 14 Pole - 090 Series",
    slug: "holder-al-tata-14-pole",
    category: "Universal Holders",
    subcategory: "090 Series Holders",
    description: "Ashok Leyland & Tata 14 pole female and male holder with special wire.",
    partNumber: "SH0100044F / SH0100044M",
    specifications: {
      "Series": "090 (2.3mm)",
      "Poles": "14 Pole",
      "Compatible": "Ashok Leyland & Tata",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090", "ashok-leyland", "tata", "14-pole"],
    applications: ["Ashok Leyland", "Tata", "Commercial Vehicles"],
  },
  {
    id: "holder-090-mahindra-tractor-al-16p",
    name: "Mahindra Tractor & Ashok Leyland Holder 16 Pole",
    slug: "holder-mahindra-tractor-al-16-pole",
    category: "Universal Holders",
    subcategory: "090 Series Holders",
    description: "Mahindra Tractor & Ashok Leyland 16 pole female and male holder with special wire.",
    partNumber: "SH0100046F / SH0100046M",
    featured: true,
    specifications: {
      "Series": "090 (2.3mm)",
      "Poles": "16 Pole",
      "Compatible": "Mahindra Tractor & Ashok Leyland",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090", "mahindra", "tractor", "ashok-leyland", "16-pole"],
    applications: ["Mahindra Tractor", "Ashok Leyland", "Agricultural", "Commercial"],
  },
  {
    id: "holder-090-maruti-tata-ace-18p",
    name: "Maruti Car & Tata ACE Holder 18 Pole",
    slug: "holder-maruti-tata-ace-18-pole",
    category: "Universal Holders",
    subcategory: "090 Series Holders",
    description: "Maruti Car & Tata ACE 18 pole female and male holder with special wire.",
    partNumber: "SH0100048F / SH0100048M",
    specifications: {
      "Series": "090 (2.3mm)",
      "Poles": "18 Pole",
      "Compatible": "Maruti Car & Tata ACE",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090", "maruti", "tata-ace", "18-pole"],
    applications: ["Maruti Cars", "Tata ACE"],
  },
  {
    id: "holder-090-tata-407-20p",
    name: "Tata 407 Holder 20 Pole - 090 Series",
    slug: "holder-tata-407-20-pole",
    category: "Universal Holders",
    subcategory: "090 Series Holders",
    description: "Tata 407 20 pole female and male holder with special wire.",
    partNumber: "SH0100050F / SH0100050M",
    featured: true,
    specifications: {
      "Series": "090 (2.3mm)",
      "Poles": "20 Pole",
      "Compatible": "Tata 407",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090", "tata-407", "20-pole"],
    applications: ["Tata 407", "Commercial Vehicles"],
  },
];

// 090 SERIES SEALED & 0110 SERIES HOLDERS
export const holder090Sealed_0110SeriesProducts: Product[] = [
  {
    id: "holder-090-sealed-2p",
    name: "Universal Holder 2 Pole - 090 Sealed",
    slug: "holder-090-sealed-2-pole",
    category: "Universal Holders",
    subcategory: "090 Series Sealed",
    description: "Universal 2 pole female and male holder with special wire. 090 sealed series.",
    partNumber: "SH0100071F / SH0100071M",
    specifications: {
      "Series": "090 Sealed (2.3mm)",
      "Poles": "2 Pole",
      "Type": "Sealed",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090", "sealed", "2-pole", "waterproof"],
    applications: ["Automotive", "Sealed Connections"],
  },
  {
    id: "holder-0110-2w-2p",
    name: "3 Wheelers Holder 2 Pole - 0110 Series",
    slug: "holder-0110-3w-2-pole",
    category: "Universal Holders",
    subcategory: "0110 Series Holders",
    description: "3 Wheelers 2 pole female and male holder with special wire. 0110 series.",
    partNumber: "SH0100122F / SH0100122M",
    specifications: {
      "Series": "0110 (2.8mm)",
      "Poles": "2 Pole",
      "Compatible": "3 Wheelers",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "0110", "3-wheeler", "2-pole"],
    applications: ["3-Wheeler", "Auto-Rickshaw"],
  },
  {
    id: "holder-0110-3w-tail-6p",
    name: "3 Wheelers & Tata Tail Light Holder 6 Pole",
    slug: "holder-0110-3w-tail-6-pole",
    category: "Universal Holders",
    subcategory: "0110 Series Holders",
    description: "Three Wheelers & Tata tail light 6 pole female and male holder with special wire.",
    partNumber: "SH0100073F / SH0100073M",
    specifications: {
      "Series": "0110 (2.8mm)",
      "Poles": "6 Pole",
      "Compatible": "3 Wheelers & Tata",
      "Application": "Tail Light",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "0110", "3-wheeler", "tata", "tail-light", "6-pole"],
    applications: ["3-Wheeler", "Tata Tail Light"],
  },
  {
    id: "holder-0110-toyota-corner-3p",
    name: "Toyota Corner Light Holder 3 Pole - 0110 Series",
    slug: "holder-0110-toyota-corner-3-pole",
    category: "Universal Holders",
    subcategory: "0110 Series Holders",
    description: "Toyota corner light 3 pole female and male holder with special wire.",
    partNumber: "SH0100124F / SH0100124M",
    specifications: {
      "Series": "0110 (2.8mm)",
      "Poles": "3 Pole",
      "Compatible": "Toyota",
      "Application": "Corner Light",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "0110", "toyota", "corner-light", "3-pole"],
    applications: ["Toyota", "Corner Light"],
  },
  {
    id: "holder-090-sealed-2w-4p",
    name: "2 Wheelers Holder 4 Pole - 090 Sealed",
    slug: "holder-090-sealed-2w-4-pole",
    category: "Universal Holders",
    subcategory: "090 Series Sealed",
    description: "2 Wheelers 4 pole female and male holder with special wire. 090 sealed series.",
    partNumber: "SH0100074F / SH0100074M",
    specifications: {
      "Series": "090 Sealed (2.3mm)",
      "Poles": "4 Pole",
      "Compatible": "2 Wheelers",
      "Type": "Sealed",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090", "sealed", "2-wheeler", "4-pole"],
    applications: ["2-Wheeler", "Motorcycle", "Sealed Connections"],
  },
  {
    id: "holder-0110-3w-3p",
    name: "3 Wheelers Holder 3 Pole - 0110 Series",
    slug: "holder-0110-3w-3-pole",
    category: "Universal Holders",
    subcategory: "0110 Series Holders",
    description: "3 Wheelers 3 pole female and male holder with special wire.",
    partNumber: "SH0100076F / SH0100076M",
    specifications: {
      "Series": "0110 (2.8mm)",
      "Poles": "3 Pole",
      "Compatible": "3 Wheelers",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "0110", "3-wheeler", "3-pole"],
    applications: ["3-Wheeler", "Auto-Rickshaw"],
  },
  {
    id: "holder-0110-3w-4p",
    name: "3 Wheelers Holder 4 Pole - 0110 Series",
    slug: "holder-0110-3w-4-pole",
    category: "Universal Holders",
    subcategory: "0110 Series Holders",
    description: "3 Wheelers 4 pole female and male holder with special wire.",
    partNumber: "SH0100123F / SH0100123M",
    specifications: {
      "Series": "0110 (2.8mm)",
      "Poles": "4 Pole",
      "Compatible": "3 Wheelers",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "0110", "3-wheeler", "4-pole"],
    applications: ["3-Wheeler", "Auto-Rickshaw"],
  },
  {
    id: "holder-0110-3w-6p",
    name: "3 Wheelers Holder 6 Pole - 0110 Series",
    slug: "holder-0110-3w-6-pole",
    category: "Universal Holders",
    subcategory: "0110 Series Holders",
    description: "3 Wheelers 6 pole female and male holder with special wire.",
    partNumber: "SH0100126F / SH0100126M",
    specifications: {
      "Series": "0110 (2.8mm)",
      "Poles": "6 Pole",
      "Compatible": "3 Wheelers",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "0110", "3-wheeler", "6-pole"],
    applications: ["3-Wheeler", "Auto-Rickshaw"],
  },
  {
    id: "holder-0110-3w-9p",
    name: "3 Wheelers Holder 9 Pole - 0110 Series",
    slug: "holder-0110-3w-9-pole",
    category: "Universal Holders",
    subcategory: "0110 Series Holders",
    description: "3 Wheelers 9 pole female and male holder with special wire.",
    partNumber: "SH0100129F / SH0100129M",
    specifications: {
      "Series": "0110 (2.8mm)",
      "Poles": "9 Pole",
      "Compatible": "3 Wheelers",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "0110", "3-wheeler", "9-pole"],
    applications: ["3-Wheeler", "Auto-Rickshaw"],
  },
];

// 0110 SERIES SPECIAL & SHUTTER HOLDERS
export const holder0110SpecialShutterProducts: Product[] = [
  {
    id: "holder-0110-eicher-2p-female",
    name: "Eicher Canter Holder 2 Pole Female - 0110",
    slug: "holder-0110-eicher-2p-female",
    category: "Universal Holders",
    subcategory: "0110 Special Series",
    description: "Eicher Canter 2 pole female holder with special wire. 0110 series.",
    partNumber: "SH0100152F",
    image: "/products/universal-holders/0110-series/SH0100152F.jpg",
    specifications: {
      "Series": "0110 (2.8mm)",
      "Poles": "2 Pole",
      "Compatible": "Eicher Canter",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female Only",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "0110", "eicher", "canter", "2-pole", "female"],
    applications: ["Eicher Canter", "Commercial Vehicles"],
  },
  {
    id: "holder-0110-universal-2p",
    name: "Universal Holder 2 Pole - 0110 Special",
    slug: "holder-0110-universal-2-pole",
    category: "Universal Holders",
    subcategory: "0110 Special Series",
    description: "Universal 2 pole female and male holder with special wire. 0110 special series.",
    partNumber: "SH0100202F / SH0100202M",
    featured: true,
    specifications: {
      "Series": "0110 Special (2.8mm)",
      "Poles": "2 Pole",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "0110", "universal", "2-pole", "special"],
    applications: ["Universal Applications"],
  },
  {
    id: "holder-0110-universal-3p",
    name: "Universal Holder 3 Pole - 0110 Special",
    slug: "holder-0110-universal-3-pole",
    category: "Universal Holders",
    subcategory: "0110 Special Series",
    description: "Universal 3 pole female and male holder with special wire.",
    partNumber: "SH0100203F / SH0100203M",
    specifications: {
      "Series": "0110 Special (2.8mm)",
      "Poles": "3 Pole",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "0110", "universal", "3-pole"],
    applications: ["Universal Applications"],
  },
  {
    id: "holder-0110-universal-4p",
    name: "Universal Holder 4 Pole - 0110 Special",
    slug: "holder-0110-universal-4-pole",
    category: "Universal Holders",
    subcategory: "0110 Special Series",
    description: "Universal 4 pole female and male holder with special wire.",
    partNumber: "SH0100204F / SH0100204M",
    specifications: {
      "Series": "0110 Special (2.8mm)",
      "Poles": "4 Pole",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "0110", "universal", "4-pole"],
    applications: ["Universal Applications"],
  },
  {
    id: "holder-0110-universal-5p",
    name: "Universal Holder 5 Pole - 0110 Special",
    slug: "holder-0110-universal-5-pole",
    category: "Universal Holders",
    subcategory: "0110 Special Series",
    description: "Universal 5 pole female and male holder with special wire.",
    partNumber: "SH0100205F / SH0100205M",
    specifications: {
      "Series": "0110 Special (2.8mm)",
      "Poles": "5 Pole",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "0110", "universal", "5-pole"],
    applications: ["Universal Applications"],
  },
  {
    id: "holder-shutter-8p",
    name: "Shutter Holder 8 Pole",
    slug: "holder-shutter-8-pole",
    category: "Universal Holders",
    subcategory: "Shutter Series",
    description: "8 pole shutter holder with special wire.",
    partNumber: "SH0100188",
    image: "/products/universal-holders/shutter-holder/SH0100188.jpg",
    specifications: {
      "Type": "Shutter",
      "Poles": "8 Pole",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "shutter", "8-pole"],
    applications: ["Automotive", "Shutter Connections"],
  },
  {
    id: "holder-shutter-10p",
    name: "Shutter Holder 10 Pole",
    slug: "holder-shutter-10-pole",
    category: "Universal Holders",
    subcategory: "Shutter Series",
    description: "10 pole shutter holder with special wire.",
    partNumber: "SH0100190",
    image: "/products/universal-holders/shutter-holder/SH0100190.jpg",
    specifications: {
      "Type": "Shutter",
      "Poles": "10 Pole",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "shutter", "10-pole"],
    applications: ["Automotive", "Shutter Connections"],
  },
  {
    id: "holder-shutter-12p",
    name: "Shutter Holder 12 Pole",
    slug: "holder-shutter-12-pole",
    category: "Universal Holders",
    subcategory: "Shutter Series",
    description: "12 pole shutter holder with special wire.",
    partNumber: "SH0100192",
    image: "/products/universal-holders/shutter-holder/SH0100192.jpg",
    featured: true,
    specifications: {
      "Type": "Shutter",
      "Poles": "12 Pole",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "shutter", "12-pole"],
    applications: ["Automotive", "Shutter Connections"],
  },
  {
    id: "holder-shutter-16p",
    name: "Shutter Holder 16 Pole",
    slug: "holder-shutter-16-pole",
    category: "Universal Holders",
    subcategory: "Shutter Series",
    description: "16 pole shutter holder with special wire.",
    partNumber: "SH0100194",
    image: "/products/universal-holders/shutter-holder/SH0100194.jpg",
    specifications: {
      "Type": "Shutter",
      "Poles": "16 Pole",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "shutter", "16-pole"],
    applications: ["Automotive", "Shutter Connections"],
  },
  {
    id: "holder-0110-eicher-5p-female",
    name: "Eicher Canter Holder 5 Pole Female",
    slug: "holder-0110-eicher-5p-female",
    category: "Universal Holders",
    subcategory: "0110 Special Series",
    description: "Eicher Canter 5 pole female holder with special wire.",
    partNumber: "SH0100155F",
    image: "/products/universal-holders/0110-series/SH0100155F.jpg",
    specifications: {
      "Series": "0110 (2.8mm)",
      "Poles": "5 Pole",
      "Compatible": "Eicher Canter",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female Only",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "0110", "eicher", "5-pole", "female"],
    applications: ["Eicher Canter"],
  },
  {
    id: "holder-0110-eicher-7p-female",
    name: "Eicher Canter Holder 7 Pole Female",
    slug: "holder-0110-eicher-7p-female",
    category: "Universal Holders",
    subcategory: "0110 Special Series",
    description: "Eicher Canter 7 pole female holder with special wire.",
    partNumber: "SH0100157F",
    image: "/products/universal-holders/0110-series/SH0100157F.jpg",
    specifications: {
      "Series": "0110 (2.8mm)",
      "Poles": "7 Pole",
      "Compatible": "Eicher Canter",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female Only",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "0110", "eicher", "7-pole", "female"],
    applications: ["Eicher Canter"],
  },
  {
    id: "holder-0110-eicher-9p-female",
    name: "Eicher Canter Holder 9 Pole Female",
    slug: "holder-0110-eicher-9p-female",
    category: "Universal Holders",
    subcategory: "0110 Special Series",
    description: "Eicher Canter 9 pole female holder with special wire.",
    partNumber: "SH0100159F",
    image: "/products/universal-holders/0110-series/SH0100159F.jpg",
    specifications: {
      "Series": "0110 (2.8mm)",
      "Poles": "9 Pole",
      "Compatible": "Eicher Canter",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female Only",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "0110", "eicher", "9-pole", "female"],
    applications: ["Eicher Canter"],
  },
  {
    id: "holder-0110-eicher-11p-female",
    name: "Eicher Canter Holder 11 Pole Female",
    slug: "holder-0110-eicher-11p-female",
    category: "Universal Holders",
    subcategory: "0110 Special Series",
    description: "Eicher Canter 11 pole female holder with special wire.",
    partNumber: "SH0100161F",
    image: "/products/universal-holders/0110-series/SH0100161F.jpg",
    specifications: {
      "Series": "0110 (2.8mm)",
      "Poles": "11 Pole",
      "Compatible": "Eicher Canter",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female Only",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "0110", "eicher", "11-pole", "female"],
    applications: ["Eicher Canter"],
  },
  {
    id: "holder-0110-eicher-13p-female",
    name: "Eicher Canter Holder 13 Pole Female",
    slug: "holder-0110-eicher-13p-female",
    category: "Universal Holders",
    subcategory: "0110 Special Series",
    description: "Eicher Canter 13 pole female holder with special wire.",
    partNumber: "SH0100163F",
    image: "/products/universal-holders/0110-series/SH0100163F.jpg",
    specifications: {
      "Series": "0110 (2.8mm)",
      "Poles": "13 Pole",
      "Compatible": "Eicher Canter",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female Only",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "0110", "eicher", "13-pole", "female"],
    applications: ["Eicher Canter"],
  },
];

// 090 SERIES PBT UNIVERSAL HOLDERS
export const holder090PBTSeriesProducts: Product[] = [
  {
    id: "holder-pbt-6p",
    name: "Universal Tata Holder 6 Pole - 090 PBT",
    slug: "holder-pbt-tata-6-pole",
    category: "Universal Holders",
    subcategory: "090 PBT Series",
    description: "Universal Tata 6 pole female and male holder with special wire. 090 PBT series.",
    partNumber: "SH0100206F / SH0100206M",
    featured: true,
    specifications: {
      "Series": "090 PBT (2.3mm)",
      "Poles": "6 Pole",
      "Compatible": "Universal Tata",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090-pbt", "tata", "6-pole"],
    applications: ["Tata Vehicles", "PBT Series"],
  },
  {
    id: "holder-pbt-8p",
    name: "Universal Holder 8 Pole - 090 PBT",
    slug: "holder-pbt-8-pole",
    category: "Universal Holders",
    subcategory: "090 PBT Series",
    description: "Universal 8 pole female and male holder with special wire. 090 PBT series.",
    partNumber: "SH0100208F / SH0100208M",
    specifications: {
      "Series": "090 PBT (2.3mm)",
      "Poles": "8 Pole",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090-pbt", "universal", "8-pole"],
    applications: ["Universal Applications", "PBT Series"],
  },
  {
    id: "holder-pbt-10p",
    name: "Universal Holder 10 Pole - 090 PBT",
    slug: "holder-pbt-10-pole",
    category: "Universal Holders",
    subcategory: "090 PBT Series",
    description: "Universal 10 pole female and male holder with special wire.",
    partNumber: "SH0100210F / SH0100210M",
    featured: true,
    specifications: {
      "Series": "090 PBT (2.3mm)",
      "Poles": "10 Pole",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090-pbt", "universal", "10-pole"],
    applications: ["Universal Applications"],
  },
  {
    id: "holder-pbt-12p",
    name: "Universal Holder 12 Pole - 090 PBT",
    slug: "holder-pbt-12-pole",
    category: "Universal Holders",
    subcategory: "090 PBT Series",
    description: "Universal 12 pole female and male holder with special wire.",
    partNumber: "SH0100212F / SH0100212M",
    featured: true,
    specifications: {
      "Series": "090 PBT (2.3mm)",
      "Poles": "12 Pole",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090-pbt", "universal", "12-pole"],
    applications: ["Universal Applications"],
  },
  {
    id: "holder-pbt-12-2p",
    name: "Universal Holder 12+2 Pole - 090 PBT",
    slug: "holder-pbt-12-2-pole",
    category: "Universal Holders",
    subcategory: "090 PBT Series",
    description: "Universal 12+2 pole female and male holder with special wire.",
    partNumber: "SH0100214F / SH0100214M",
    specifications: {
      "Series": "090 PBT (2.3mm)",
      "Poles": "12+2 Pole",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090-pbt", "universal", "12-2-pole"],
    applications: ["Universal Applications"],
  },
  {
    id: "holder-pbt-16p",
    name: "Universal Holder 16 Pole - 090 PBT",
    slug: "holder-pbt-16-pole",
    category: "Universal Holders",
    subcategory: "090 PBT Series",
    description: "Universal 16 pole female and male holder with special wire.",
    partNumber: "SH0100216F / SH0100216M",
    specifications: {
      "Series": "090 PBT (2.3mm)",
      "Poles": "16 Pole",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090-pbt", "universal", "16-pole"],
    applications: ["Universal Applications"],
  },
  {
    id: "holder-pbt-18p",
    name: "Universal Holder 18 Pole - 090 PBT",
    slug: "holder-pbt-18-pole",
    category: "Universal Holders",
    subcategory: "090 PBT Series",
    description: "Universal 18 pole female and male holder with special wire.",
    partNumber: "SH0100218F / SH0100218M",
    specifications: {
      "Series": "090 PBT (2.3mm)",
      "Poles": "18 Pole",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090-pbt", "universal", "18-pole"],
    applications: ["Universal Applications"],
  },
  {
    id: "holder-pbt-20p",
    name: "Universal Holder 20 Pole - 090 PBT",
    slug: "holder-pbt-20-pole",
    category: "Universal Holders",
    subcategory: "090 PBT Series",
    description: "Universal 20 pole female and male holder with special wire.",
    partNumber: "SH0100220F / SH0100220M",
    specifications: {
      "Series": "090 PBT (2.3mm)",
      "Poles": "20 Pole",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090-pbt", "universal", "20-pole"],
    applications: ["Universal Applications"],
  },
  {
    id: "holder-pbt-22p",
    name: "Universal Holder 22 Pole - 090 PBT",
    slug: "holder-pbt-22-pole",
    category: "Universal Holders",
    subcategory: "090 PBT Series",
    description: "Universal 22 pole female and male holder with special wire.",
    partNumber: "SH0100222F / SH0100222M",
    specifications: {
      "Series": "090 PBT (2.3mm)",
      "Poles": "22 Pole",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090-pbt", "universal", "22-pole"],
    applications: ["Universal Applications"],
  },
];

// 090 SERIES WATER PROOF UNIVERSAL HOLDERS
export const holder090WaterProofProducts: Product[] = [
  {
    id: "holder-wp-maruti-injector-2p",
    name: "Universal Right Injector Maruti Holder 2 Pole - Water Proof",
    slug: "holder-wp-maruti-injector-2-pole",
    category: "Universal Holders",
    subcategory: "090 Water Proof Series",
    description: "Universal right injector Maruti 2 pole female and male holder with special wire. 090 water proof series.",
    partNumber: "SH0100302F / SH0100302M",
    featured: true,
    specifications: {
      "Series": "090 Water Proof (2.3mm)",
      "Poles": "2 Pole",
      "Compatible": "Maruti Right Injector",
      "Type": "Water Proof",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090-waterproof", "maruti", "injector", "2-pole"],
    applications: ["Maruti Injector", "Waterproof Connections"],
  },
  {
    id: "holder-wp-universal-3p",
    name: "Universal Holder 3 Pole - Water Proof",
    slug: "holder-wp-universal-3-pole",
    category: "Universal Holders",
    subcategory: "090 Water Proof Series",
    description: "Universal 3 pole female and male holder with special wire. Water proof.",
    partNumber: "SH0100303F / SH0100303M",
    specifications: {
      "Series": "090 Water Proof (2.3mm)",
      "Poles": "3 Pole",
      "Type": "Water Proof",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090-waterproof", "universal", "3-pole"],
    applications: ["Universal Applications", "Waterproof"],
  },
  {
    id: "holder-wp-universal-4p",
    name: "Universal Holder 4 Pole - Water Proof",
    slug: "holder-wp-universal-4-pole",
    category: "Universal Holders",
    subcategory: "090 Water Proof Series",
    description: "Universal 4 pole female and male holder with special wire. Water proof.",
    partNumber: "SH0100304F / SH0100304M",
    specifications: {
      "Series": "090 Water Proof (2.3mm)",
      "Poles": "4 Pole",
      "Type": "Water Proof",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090-waterproof", "universal", "4-pole"],
    applications: ["Universal Applications", "Waterproof"],
  },
  {
    id: "holder-wp-ac-switch-honda-6p",
    name: "Universal AC Switch Honda ZX Holder 6 Pole - Water Proof",
    slug: "holder-wp-ac-switch-honda-6-pole",
    category: "Universal Holders",
    subcategory: "090 Water Proof Series",
    description: "Universal AC switch Honda ZX 6 pole female and male holder with special wire.",
    partNumber: "SH0100306F / SH0100306M",
    specifications: {
      "Series": "090 Water Proof (2.3mm)",
      "Poles": "6 Pole",
      "Compatible": "Honda ZX AC Switch",
      "Type": "Water Proof",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090-waterproof", "honda", "ac-switch", "6-pole"],
    applications: ["Honda ZX", "AC Switch"],
  },
  {
    id: "holder-wp-universal-8p",
    name: "Universal Holder 8 Pole - Water Proof",
    slug: "holder-wp-universal-8-pole",
    category: "Universal Holders",
    subcategory: "090 Water Proof Series",
    description: "Universal 8 pole female and male holder with special wire.",
    partNumber: "SH0100308F / SH0100308M",
    specifications: {
      "Series": "090 Water Proof (2.3mm)",
      "Poles": "8 Pole",
      "Type": "Water Proof",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090-waterproof", "universal", "8-pole"],
    applications: ["Universal Applications", "Waterproof"],
  },
  {
    id: "holder-wp-universal-10p",
    name: "Universal Holder 10 Pole - Water Proof",
    slug: "holder-wp-universal-10-pole",
    category: "Universal Holders",
    subcategory: "090 Water Proof Series",
    description: "Universal 10 pole female and male holder with special wire.",
    partNumber: "SH0100310F / SH0100310M",
    specifications: {
      "Series": "090 Water Proof (2.3mm)",
      "Poles": "10 Pole",
      "Type": "Water Proof",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090-waterproof", "universal", "10-pole"],
    applications: ["Universal Applications", "Waterproof"],
  },
  {
    id: "holder-wp-maruti-mpfi-12p",
    name: "Maruti Car MPFI Holder 12 Pole - Water Proof",
    slug: "holder-wp-maruti-mpfi-12-pole",
    category: "Universal Holders",
    subcategory: "090 Water Proof Series",
    description: "Maruti Car MPFI 12 pole female and male holder with 4mm deluxe wire.",
    partNumber: "SH0100312F / SH0100312M",
    featured: true,
    specifications: {
      "Series": "090 Water Proof (2.3mm)",
      "Poles": "12 Pole",
      "Compatible": "Maruti Car MPFI",
      "Type": "Water Proof",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090-waterproof", "maruti", "mpfi", "12-pole"],
    applications: ["Maruti MPFI", "Fuel Injection"],
  },
  {
    id: "holder-wp-tata-14p",
    name: "Tata Holder 14 Pole - Water Proof",
    slug: "holder-wp-tata-14-pole",
    category: "Universal Holders",
    subcategory: "090 Water Proof Series",
    description: "Tata 14 pole female and male holder with 4mm deluxe wire.",
    partNumber: "SH0100314F / SH0100314M",
    specifications: {
      "Series": "090 Water Proof (2.3mm)",
      "Poles": "14 Pole",
      "Compatible": "Tata",
      "Type": "Water Proof",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090-waterproof", "tata", "14-pole"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "holder-wp-maruti-mpfi-injector-16p",
    name: "Maruti MPFI Injector Holder 16 Pole - Water Proof",
    slug: "holder-wp-maruti-mpfi-injector-16-pole",
    category: "Universal Holders",
    subcategory: "090 Water Proof Series",
    description: "Maruti MPFI Injector 16 pole female and male holder with 4mm deluxe wire.",
    partNumber: "SH0100316F / SH0100316M",
    featured: true,
    specifications: {
      "Series": "090 Water Proof (2.3mm)",
      "Poles": "16 Pole",
      "Compatible": "Maruti MPFI Injector",
      "Type": "Water Proof",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090-waterproof", "maruti", "mpfi", "injector", "16-pole"],
    applications: ["Maruti MPFI", "Injector"],
  },
  {
    id: "holder-wp-ashok-leyland-1p",
    name: "Universal Ashok Leyland Holder 1 Pole - Water Proof",
    slug: "holder-wp-al-1-pole",
    category: "Universal Holders",
    subcategory: "090 Water Proof Series",
    description: "Universal Ashok Leyland 1 pole female and male holder with special wire.",
    partNumber: "SH0100401F / SH0100401M",
    specifications: {
      "Series": "090 Water Proof (2.3mm)",
      "Poles": "1 Pole",
      "Compatible": "Ashok Leyland",
      "Type": "Water Proof",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090-waterproof", "ashok-leyland", "1-pole"],
    applications: ["Ashok Leyland"],
  },
  {
    id: "holder-wp-ashok-leyland-2p",
    name: "Universal Ashok Leyland Holder 2 Pole - Water Proof",
    slug: "holder-wp-al-2-pole",
    category: "Universal Holders",
    subcategory: "090 Water Proof Series",
    description: "Universal Ashok Leyland 2 pole female and male holder with special wire.",
    partNumber: "SH0100402F / SH0100402M",
    specifications: {
      "Series": "090 Water Proof (2.3mm)",
      "Poles": "2 Pole",
      "Compatible": "Ashok Leyland",
      "Type": "Water Proof",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090-waterproof", "ashok-leyland", "2-pole"],
    applications: ["Ashok Leyland"],
  },
  {
    id: "holder-wp-ashok-leyland-3p",
    name: "Universal Ashok Leyland Holder 3 Pole - Water Proof",
    slug: "holder-wp-al-3-pole",
    category: "Universal Holders",
    subcategory: "090 Water Proof Series",
    description: "Universal Ashok Leyland 3 pole female and male holder with special wire.",
    partNumber: "SH0100403F / SH0100403M",
    specifications: {
      "Series": "090 Water Proof (2.3mm)",
      "Poles": "3 Pole",
      "Compatible": "Ashok Leyland",
      "Type": "Water Proof",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090-waterproof", "ashok-leyland", "3-pole"],
    applications: ["Ashok Leyland"],
  },
  {
    id: "holder-wp-tata-4p",
    name: "Universal Tata Holder 4 Pole - Water Proof",
    slug: "holder-wp-tata-4-pole",
    category: "Universal Holders",
    subcategory: "090 Water Proof Series",
    description: "Universal Tata 4 pole female and male holder with special wire.",
    partNumber: "SH0100404F / SH0100404M",
    specifications: {
      "Series": "090 Water Proof (2.3mm)",
      "Poles": "4 Pole",
      "Compatible": "Tata",
      "Type": "Water Proof",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090-waterproof", "tata", "4-pole"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "holder-wp-tata-6p",
    name: "Universal Tata Holder 6 Pole - Water Proof",
    slug: "holder-wp-tata-6-pole",
    category: "Universal Holders",
    subcategory: "090 Water Proof Series",
    description: "Universal Tata 6 pole female and male holder with special wire.",
    partNumber: "SH0100406F / SH0100406M",
    specifications: {
      "Series": "090 Water Proof (2.3mm)",
      "Poles": "6 Pole",
      "Compatible": "Tata",
      "Type": "Water Proof",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090-waterproof", "tata", "6-pole"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "holder-wp-tata-8p",
    name: "Universal Tata Holder 8 Pole - Water Proof",
    slug: "holder-wp-tata-8-pole",
    category: "Universal Holders",
    subcategory: "090 Water Proof Series",
    description: "Universal Tata 8 pole female and male holder with special wire.",
    partNumber: "SH0100408F / SH0100408M",
    specifications: {
      "Series": "090 Water Proof (2.3mm)",
      "Poles": "8 Pole",
      "Compatible": "Tata",
      "Type": "Water Proof",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090-waterproof", "tata", "8-pole"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "holder-wp-tata-10p",
    name: "Universal Tata Holder 10 Pole - Water Proof",
    slug: "holder-wp-tata-10-pole",
    category: "Universal Holders",
    subcategory: "090 Water Proof Series",
    description: "Universal Tata 10 pole female and male holder with special wire.",
    partNumber: "SH0100410F / SH0100410M",
    featured: true,
    specifications: {
      "Series": "090 Water Proof (2.3mm)",
      "Poles": "10 Pole",
      "Compatible": "Tata",
      "Type": "Water Proof",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090-waterproof", "tata", "10-pole"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "holder-wp-ashok-leyland-12p",
    name: "Universal Ashok Leyland Holder 12 Pole - Water Proof",
    slug: "holder-wp-al-12-pole",
    category: "Universal Holders",
    subcategory: "090 Water Proof Series",
    description: "Universal Ashok Leyland 12 pole female and male holder with special wire.",
    partNumber: "SH0100412F / SH0100412M",
    specifications: {
      "Series": "090 Water Proof (2.3mm)",
      "Poles": "12 Pole",
      "Compatible": "Ashok Leyland",
      "Type": "Water Proof",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090-waterproof", "ashok-leyland", "12-pole"],
    applications: ["Ashok Leyland"],
  },
  {
    id: "holder-wp-tata-ace-cng-12-3p",
    name: "Tata Ace CNG Holder 12+3 Pole - Water Proof",
    slug: "holder-wp-tata-ace-cng-12-3-pole",
    category: "Universal Holders",
    subcategory: "090 Water Proof Series",
    description: "Tata Ace CNG 12+3 pole female and male holder with special + 4mm deluxe wire.",
    partNumber: "SH0100415F / SH0100415M",
    featured: true,
    specifications: {
      "Series": "090 Water Proof (2.3mm)",
      "Poles": "12+3 Pole",
      "Compatible": "Tata Ace CNG",
      "Type": "Water Proof",
      "Wire Type": "Special + 4mm Deluxe",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090-waterproof", "tata-ace", "cng", "12-3-pole"],
    applications: ["Tata Ace CNG"],
  },
  {
    id: "holder-wp-tata-16p",
    name: "Universal Tata Holder 16 Pole - Water Proof",
    slug: "holder-wp-tata-16-pole",
    category: "Universal Holders",
    subcategory: "090 Water Proof Series",
    description: "Universal Tata 16 pole female and male holder with special wire.",
    partNumber: "SH0100416F / SH0100416M",
    specifications: {
      "Series": "090 Water Proof (2.3mm)",
      "Poles": "16 Pole",
      "Compatible": "Tata",
      "Type": "Water Proof",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Gender": "Female & Male Set",
      "Packing": "10 Pcs",
    },
    tags: ["holder", "090-waterproof", "tata", "16-pole"],
    applications: ["Tata Vehicles"],
  },
];
